
// 扁平化路由地址
export function flattenRouterPath(routes, parentPath = '', pathAuthority = {}) {
  if (!routes || !Array.isArray(routes)) return pathAuthority;
  routes.forEach(route => {
    const { path, authority, children, redirect_path } = route;
    let real_path = `${parentPath}/${path}`;
    real_path = real_path.replace(/\/+/g, '/');
    // 默认权限是admin权限

    pathAuthority[real_path] = authority || 'admin';
    pathAuthority.redirect_path = redirect_path || '/';

    //pathAuthority.redirect_path = "http://loantest.yimeijian.cn/auth/joshid"
    
    if (children) {
      flattenRouterPath(children, path, pathAuthority);
    }
   
  })

  return pathAuthority;
}

// 转换时间
 export function  formatDate (date) {
  var date = new Date(date);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  var second = date.getSeconds();
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d +'   '+ h + ' :'  + minute;
}




// WEBPACK FOOTER //
// ./src/utils/utils.js